import { useEffect, useRef } from 'react';
import { useAEMResource, useCssReady } from '@hooks';
import { AEM_HEADER_HEIGHT } from '@config/constants';

const HeaderPlaceholder = () => (
  <div
    aria-hidden="true"
    style={{
      height: `${AEM_HEADER_HEIGHT}px`,
    }}
  />
);

const Header = () => {
  const {
    header,
    headerLoaded,
    headerCssReady,
  } = useAEMResource();
  const headerRef = useRef<HTMLDivElement>(null);
  const globalCssReady = useCssReady(headerLoaded && Boolean(header));
  const cssReady = globalCssReady && headerCssReady;

  // N4 header-slim activates via inline scripts + a bootstrap img onload.
  // Inject the full fragment markup so those handlers can run; html-react-parser
  // would strip them and manual script re-loading hangs on data: URLs.
  useEffect(() => {
    if (!headerRef.current || !header || !cssReady) {
      return;
    }

    headerRef.current.innerHTML = header;
  }, [header, cssReady]);

  if (!headerLoaded || !header || !cssReady) {
    return <HeaderPlaceholder />;
  }

  return <div ref={headerRef} />;
};

export { Header };
